import { memo } from "react";
import Resource from 'ui/layouts/Resource';
import BlacklistedConsumersActions from "./BlacklistedConsumersActions";
import BlacklistedConsumersTable from "./BlacklistedConsumersTable";

const BlacklistedConsumers = () => (
    <Resource
        breadcrumbsProps={{
            heading: 'Blacklisted Consumers',
            links: [{ name: '' }],
            action: (
                <BlacklistedConsumersActions />
            )
        }}
    >
        <BlacklistedConsumersTable />
    </Resource>
);

export default memo(BlacklistedConsumers);
